import { render } from "./LogMessageComponent.vue?vue&type=template&id=ca68f084&ts=true"
import script from "./LogMessageComponent.vue?vue&type=script&lang=ts"
export * from "./LogMessageComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__